export const siteData = {
  clinic: {
    name: "Young Vitality Acupuncture",
    practitioner: "Young Burton",
    phone: "(424) 744-7898",
    phoneLink: "tel:+14247447898",
    email: "yvacuhealing@gmail.com",
    address: {
      street: "7041 Owensmouth Ave, Ste 106",
      city: "Los Angeles",
      state: "CA",
      zip: "91303",
      area: "Woodland Hills / Canoga Park"
    },
    hours: [
      { day: "Monday", hours: "9:00 AM \u2013 6:00 PM" },
      { day: "Tuesday", hours: "9:00 AM \u2013 7:00 PM" },
      { day: "Wednesday", hours: "9:00 AM \u2013 6:00 PM" },
      { day: "Thursday", hours: "9:00 AM \u2013 7:00 PM" },
      { day: "Friday", hours: "9:00 AM \u2013 6:00 PM" },
      { day: "Saturday", hours: "Closed" },
      { day: "Sunday", hours: "Closed" }
    ],
    rating: 5.0,
    ratingSource: "Yelp & Google"
  },
  hero: {
    headline: "Expert Healing Tailored to You",
    subheadline: "Experience a personalized path to wellness with Woodland Hills' premier acupuncture and cupping specialist.",
    ctaPrimary: "Book an Appointment",
    ctaSecondary: "Call (424) 744-7898"
  },
  about: {
    title: "A Healer Who Listens",
    description: "Young Burton dedicates a full 45 minutes to each patient, combining the art of cupping therapy, soothing massage (5\u201310 minutes), and precision acupuncture for a comprehensive, personalized treatment experience.",
    extendedDescription: "Our clinic is a small, clean, and comfortable private practice where every detail is designed with your comfort in mind. From the moment you walk in, you\u2019ll feel the difference of truly personalized care.",
    highlights: [
      { label: "60-Minute Sessions", description: "Full hour dedicated entirely to your healing" },
      { label: "Combined Therapies", description: "Cupping, massage & acupuncture in every visit" },
      { label: "Private Practice", description: "Small, clean & comfortable clinic environment" },
      { label: "Patient-Centered", description: "Compassionate care tailored to your needs" }
    ]
  },
  services: [
    {
      id: 1,
      title: "Acupuncture",
      description: "Precision needle therapy targeting pain and imbalance. Specializing in deep needle technique upon request for enhanced therapeutic results.",
      accent: "purple"
    },
    {
      id: 2,
      title: "Cupping Therapy",
      description: "Traditional cupping to improve circulation, relieve muscle tension, and promote deep healing throughout the body.",
      accent: "blue"
    },
    {
      id: 3,
      title: "Manual Massage Therapy",
      description: "Therapeutic massage integrated into every session, combining 5\u201310 minutes of targeted bodywork to complement your treatment.",
      accent: "orange"
    },
    {
      id: 4,
      title: "Sciatica & Back Pain",
      description: "Specialized treatment protocols for sciatica, spinal stenosis, and chronic neck and back pain relief.",
      accent: "pink"
    },
    {
      id: 5,
      title: "TMJ Treatment",
      description: "Targeted acupuncture and therapy for temporomandibular joint disorders, alleviating jaw pain and tension.",
      accent: "green"
    },
    {
      id: 6,
      title: "Personal Injury Cases",
      description: "Comprehensive treatment plans for personal injury recovery, helping you restore mobility and well-being.",
      accent: "grey"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Michael R.",
      quote: "Best acupuncturist I've seen in 30 years. Young truly understands the art of healing and makes every session count.",
      rating: 5
    },
    {
      id: 2,
      name: "Sandra L.",
      quote: "I came in with intense sciatica pain that had plagued me for months. After just a few sessions, I felt tremendous relief. Truly life-changing.",
      rating: 5
    },
    {
      id: 3,
      name: "David K.",
      quote: "Increased mobility in just one appointment. Young's technique is unlike anything I've experienced. Highly recommend.",
      rating: 5
    },
    {
      id: 4,
      name: "Jennifer W.",
      quote: "The combination of cupping and acupuncture worked wonders for my chronic back pain. Young listens and creates a plan that actually works.",
      rating: 5
    },
    {
      id: 5,
      name: "Robert T.",
      quote: "A truly personalized experience. Young takes her time and genuinely cares about your healing journey. The clinic is spotless and welcoming.",
      rating: 5
    }
  ],
  patientInfo: {
    insurance: [
      "Triwest VA (Veterans)",
      "Workers' Compensation",
      "Blue Shield PPO",
      "Various insurance providers",
      "Credit cards accepted",
      "Flexible payment options"
    ],
    amenities: [
      "LGBTQ+ Friendly",
      "Safe Neighborhood",
      "Private Treatment Rooms",
      "Easy Parking",
      "Credit Cards Accepted",
      "Comfortable Environment"
    ]
  },
  images: {
    acupuncture: "https://images.unsplash.com/photo-1598555763574-dca77e10427e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxhY3VwdW5jdHVyZXxlbnwwfHx8fDE3NzA5MTc4MzZ8MA&ixlib=rb-4.1.0&q=85&w=800",
    cupping: "https://images.unsplash.com/photo-1598555748505-ccca0d9b9f7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjdXBwaW5nJTIwdGhlcmFweXxlbnwwfHx8fDE3NzA5MTc4NDF8MA&ixlib=rb-4.1.0&q=85&w=800",
    wellness: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHx3ZWxsbmVzcyUyMHNwYXxlbnwwfHx8fDE3NzA5MDkwMjN8MA&ixlib=rb-4.1.0&q=85&w=800",
    healing: "https://images.unsplash.com/photo-1579291465309-278e8665628d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxoZWFsaW5nJTIwcmVsYXhhdGlvbnxlbnwwfHx8fDE3NzA5MTc4NTB8MA&ixlib=rb-4.1.0&q=85&w=800"
  }
};
